// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3b3S8","heading":"styles-module--heading--Lwc7J","paragraph":"styles-module--paragraph--2jQnD"};